import { TriangleAlert, X } from 'lucide-react';
import { useState } from 'react';

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';

interface ErrorMessagePopoverProps {
  message: string | null | undefined;
}

export function ErrorMessagePopover({ message }: ErrorMessagePopoverProps) {
  const [isOpen, setIsOpen] = useState(false);

  if (!message) {
    return null;
  }

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label="Show error message"
          className="cursor-pointer"
        >
          <TriangleAlert size={16} className="text-error-700" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-80 flex items-start gap-2 p-3">
        <p className="flex-1 text-sm text-error-700">{message}</p>
        <button
          type="button"
          aria-label="Close"
          className="cursor-pointer text-zinc-400 hover:text-zinc-50"
          onClick={() => setIsOpen(false)}
        >
          <X size={14} />
        </button>
      </PopoverContent>
    </Popover>
  );
}
